import { useState } from "react";
import { axiosInstance } from "../services/axiosConfig";
import { BASE_URL, FETCH_CLIENT_CONFIG, FETCH_CLIENT_CONFIG_BY_ID } from "../utility/constants";

const useFetchClientConfig = () => {
    const [response, setResponse] = useState(null);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const FetchClientConfig = async () => {
        setIsLoading(true);
        console.log(BASE_URL, FETCH_CLIENT_CONFIG);
        try {
            const res = await axiosInstance.get(`${BASE_URL}${FETCH_CLIENT_CONFIG
            }`);
            setResponse(res);
            setError(null);
        } catch (err) {
            setError(err);
            console.error('Error fetching client config:', err);
        } finally {
            setIsLoading(false);
        }
    };

    const FetchClientConfigById = async (clientId) => {
        setIsLoading(true);

        try {
            const res = await axiosInstance.get(`${BASE_URL}${FETCH_CLIENT_CONFIG_BY_ID}${clientId}/`);
            setResponse(res);
            setError(null);
        } catch (err) {
            setError(err);
            console.error('Error fetching client config by ID:', err);
        } finally {
            setIsLoading(false);
        }
    };

    return { response, error, isLoading, FetchClientConfig, FetchClientConfigById };
};

export default useFetchClientConfig;
